import { Button, Modal, Tag } from '@maxtropy/components';
import React, { FC, MutableRefObject, useRef, useState } from 'react';
import AreaModal, { AreaModalRef } from './AreaModal';
import styles from './index.module.scss';
import { useRequest } from 'ahooks';
import { apiV2ComprehensiveLabelListPost } from '@maxtropy/device-customer-apis-v2';
import { TabKey } from '@/pages/Circuit/LabelsManage';

interface MultiAreaModalSelectProps {
  onChange?: (val?: number[]) => void;
  value?: number[];
  isEditing: boolean;
}

const MultiAreaModalSelect: FC<MultiAreaModalSelectProps> = props => {
  const { value, onChange, isEditing } = props;
  const areaRef: MutableRefObject<AreaModalRef | null> = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onClose = (e: React.MouseEvent<HTMLElement>, areaId: number) => {
    e.preventDefault();
    Modal.confirm({
      title: '确定移除？',
      okText: '确定',
      onOk: async () => {
        const _areaIds = value?.filter(id => id !== areaId);
        onChange!(_areaIds);
      },
    });
  };

  const onOk = () => {
    setIsModalVisible(false);
    const _areaIds: Array<number> | undefined = areaRef.current?.selectedRowKeys;
    onChange?.(_areaIds);
  };

  const { data } = useRequest(() =>
    apiV2ComprehensiveLabelListPost({ id: TabKey.DEVICE }).then(res => {
      return res.list;
    })
  );

  return (
    <>
      <Button type="link" size="small" disabled={!isEditing} onClick={() => setIsModalVisible(true)}>
        {value?.length ? '继续选择设备标签' : '请选择设备标签'}
      </Button>
      <div className={styles.value}>
        {value?.map(areaId => {
          return (
            <Tag key={areaId} closable={isEditing} className={styles.tag} onClose={e => onClose(e, areaId)}>
              {data?.find(item => item.id === areaId)?.name}
            </Tag>
          );
        })}
      </div>
      <Modal
        size="big"
        title="监测区域选择"
        open={isModalVisible}
        destroyOnClose
        onOk={onOk}
        onCancel={() => setIsModalVisible(false)}
      >
        <AreaModal areaIds={value} ref={areaRef} />
      </Modal>
    </>
  );
};

export default MultiAreaModalSelect;
